import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// import { GameState } from './lib/GameState';
// import { Player } from './lib/Player';
// import { Card } from './lib/Card';

// import PlayerModule from './store/player';

// const myMod = getModule(PlayerModule);
// console.log(myMod.count);

// const client = new Colyseus.Client('ws://localhost:2567');
// // const client = new Colyseus.Client('ws://playifgame.herokuapp.com/:2567');
// client.joinOrCreate<GameState>('my_room2', { name: 'Tim' }).then((room) => {
//   console.log(room.sessionId, 'joined', room.name);
//   myMod.setRoom(room);

//   room.onStateChange((state) => {
//     myMod.setDeck(state.cards);
//     myMod.increment(2);
//     // state.players.onAdd = (item, key) => {

//     // };
//     console.log(room.name, 'has new state:', state.toJSON(),
//       state.cards.toArray(), state.players.get(room.sessionId));
//   });

//   room.onMessage('powerup', (message) => {
//     console.log(room.sessionId, 'received on', room.name, message);
//   });

//   room.onMessage(Card, (message) => {
//     console.log(room.sessionId, 'received on 2', room.name, message);
//   });

//   room.onMessage(Player, (message) => {
//     console.log(room.sessionId, 'received on 2', room.name, message);
//   });

//   // room.leave(false);
// }).catch((e) => {
//   console.log('JOIN ERROR', e);
// });

// Vue.use(VuePeerJS, new Peer(), { store });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
